export default "__VITE_ASSET__YediMNSW__"